import { HttpClient } from '@angular/common/http';
import { inject, Injectable, signal } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import type { CadCheckReport } from '@infinitform/platform-core';

/**
 * The geometry check of the open project's imported CAD (`project.cadCheck`),
 * and which of its notices the user has put away for this session.
 */
@Injectable({ providedIn: 'root' })
export class CadCheckService {
  private http = inject(HttpClient);
  private loading = 0;

  readonly report = signal<CadCheckReport | null>(null);
  readonly dismissed = signal<ReadonlySet<string>>(new Set());

  /**
   * Fetches the report of a newly opened project. Never fails: a project
   * without one, or one that cannot be read, simply shows no notices.
   */
  async load(url: string | null | undefined): Promise<void> {
    const ticket = ++this.loading;
    this.report.set(null);
    this.dismissed.set(new Set());
    if (!url) return;
    try {
      const report = await lastValueFrom(this.http.get<CadCheckReport>(url));
      if (ticket === this.loading) this.report.set(report ?? null);
    } catch (err) {
      console.warn('[CadCheck] report not loaded:', (err as Error)?.message ?? err);
    }
  }

  dismiss(...codes: string[]): void {
    this.dismissed.update((dismissed) => new Set([...dismissed, ...codes]));
  }
}
